import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

const INDIA = ["Kerala", "Kashmir", "Goa", "Himachal Pradesh", "Rajasthan", "Andaman"];
const INTL = ["Dubai, UAE", "Thailand", "Bali, Indonesia", "Maldives", "France & Switzerland", "Vietnam"];

export const Footer = () => (
  <footer className="bg-ink text-bone/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <p className="mb-4"><span className="inline-flex bg-white rounded-xl px-4 py-2.5"><img src="/logo.png" alt="click2trip — we Exchange Happiness" className="h-9 w-auto" /></span></p>
        <p className="text-sm leading-relaxed text-bone/60 mb-6">
          We Exchange Happiness since 2011. Verified stays, transparent pricing and a trip manager on WhatsApp — from first hello to touchdown back home.
        </p>
        <div className="flex gap-3">
          <a href={SITE.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram"
            className="w-9 h-9 rounded-full border border-bone/20 flex items-center justify-center hover:bg-sun hover:border-sun transition-colors"><Instagram size={16} /></a>
          <a href={SITE.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook"
            className="w-9 h-9 rounded-full border border-bone/20 flex items-center justify-center hover:bg-sun hover:border-sun transition-colors"><Facebook size={16} /></a>
          <a href={SITE.socials.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="footer-youtube"
            className="w-9 h-9 rounded-full border border-bone/20 flex items-center justify-center hover:bg-sun hover:border-sun transition-colors"><Youtube size={16} /></a>
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-sun mb-5">India Packages</p>
        <ul className="space-y-2.5 text-sm">
          {INDIA.map((d) => (
            <li key={d}><Link to={`/packages?category=domestic&search=${encodeURIComponent(d)}`} data-testid={`footer-india-${d.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-sun transition-colors">{d} Tour Packages</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-sun mb-5">International Packages</p>
        <ul className="space-y-2.5 text-sm">
          {INTL.map((d) => (
            <li key={d}><Link to={`/packages?category=international&search=${encodeURIComponent(d.split(",")[0])}`} data-testid={`footer-intl-${d.split(",")[0].toLowerCase()}`} className="hover:text-sun transition-colors">{d} Tour Packages</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-sun mb-5">Get in Touch</p>
        <ul className="space-y-3.5 text-sm">
          <li><a href={`tel:${SITE.phoneRaw}`} data-testid="footer-phone" className="flex items-start gap-2.5 hover:text-sun transition-colors"><Phone size={15} className="mt-0.5 shrink-0" />{SITE.phoneDisplay}</a></li>
          <li><a href={waLink("Hi click2trip!")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-start gap-2.5 hover:text-sun transition-colors"><Instagram size={15} className="mt-0.5 shrink-0 opacity-0" /><span className="-ml-6">WhatsApp: {SITE.phoneDisplay}</span></a></li>
          <li><a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-start gap-2.5 hover:text-sun transition-colors"><Mail size={15} className="mt-0.5 shrink-0" />{SITE.email}</a></li>
          <li className="flex items-start gap-2.5 text-bone/60"><MapPin size={15} className="mt-0.5 shrink-0" />{SITE.address}</li>
          <li className="flex items-start gap-2.5 text-bone/60"><Clock size={15} className="mt-0.5 shrink-0" />{SITE.hours}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-bone/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-bone/50">
        <p>© {new Date().getFullYear()} click2trip. All rights reserved.</p>
        <div className="flex gap-5">
          <Link to="/about" data-testid="footer-about-link" className="hover:text-sun">About</Link>
          <Link to="/faqs" data-testid="footer-faq-link" className="hover:text-sun">FAQs</Link>
          <Link to="/gallery" data-testid="footer-gallery-link" className="hover:text-sun">Gallery</Link>
          <Link to="/policies/terms" data-testid="footer-terms-link" className="hover:text-sun">Terms</Link>
          <Link to="/policies/privacy" data-testid="footer-privacy-link" className="hover:text-sun">Privacy</Link>
          <Link to="/policies/refund" data-testid="footer-refund-link" className="hover:text-sun">Refunds</Link>
        </div>
      </div>
    </div>
  </footer>
);
